export default (theme) => ({
  page: {
    [theme.breakpoints.down('xs')]: {
      paddingTop: 8,
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '-8px',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '27%',
    flexShrink: 0,
    fontWeight: 'bold',
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    flexBasis: '40%',
  },
  thirdHeading: {
    marginRight: 5,
    display: 'inline-block',
    color: theme.palette.text.secondary,
  },
  createdDate: {
    color: theme.palette.secondary.main,
    display: 'inline-block',
  },
  expandPanelIcon: {
    color: theme.palette.secondary.main,
    textAlign: 'center',
    marginRight: '15px',
    width: '60px',
    height: '40px',
  },
  expandPanelIconTypography: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    fontSize: '9px',
  },
  expandPanelSummary: {
    alignItems: 'center',
  },
  expandPanelData: {
    fontWeight: 'bold',
    display: 'inline-block',
    color: '#fff',
    fontSize: theme.typography.pxToRem(15),
    margin: '0 16px',
    padding: '3px 8px',
    borderRadius: '20px',
  },
  expandPanelDetailsText: {
    paddingRight: '24px',
  },
  expandPanelDetailsIconPrimary: {
    position: 'absolute',
    right: '8px',
    top: '40%',
  },
  expandPanelDetailsIconSecondary: {
    position: 'absolute',
    right: '8px',
    top: '67%',
  },
  responses: {
    backgroundColor: '#15b940',
  },
  opens: { backgroundColor: '#d89300' },
  total: {
    backgroundColor: '#930766',
  },
  tile: {
    borderRadius: 20,
    padding: theme.spacing.unit * 2,
    position: 'relative',
  },
  dataPanel: {
    textAlign: 'center',
    color: '#fff',
    padding: theme.spacing.unit * 2,
    borderRadius: 20,
  },
  dataPanelSection: {
    textAlign: 'center',
  },
  dataPanelEmailSection: {
    fontSize: '11px',
    fontWeight: 'bold',
  },
  dataPanelButton: {
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
  },
  dataPanelTitle: {
    fontWeight: 'bold',
    fontSize: '16px',
  },
  button: {
    margin: theme.spacing.unit,
  },
  
  addButton: {
    color: '#fff',
    background: theme.palette.secondary.main,
    '&:hover': {
      background: theme.palette.secondary.dark,
    },
  },
  progress: {
    margin: theme.spacing.unit * 2,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  sort: {
    background: theme.palette.secondary.main,
    borderRadius: 25,
    textAlign: 'right',
    padding: theme.spacing.unit,
  },
  expansionPanelRoot: {
    '&:first-child': {
      borderTopLeftRadius: 35,
      borderTopRightRadius: 35,
    },
    '&:last-child': {
      borderBottomLeftRadius: 35,
      borderBottomRightRadius: 35,
    },
  },
  expansionPanelExpanded: {
    borderRadius: 35,
  },
  toggleViewButton: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.down('xs')]: {
      color: '#fff',
      padding: '6px 8px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '8px',
    },
  },
  secondary: {
    color: theme.palette.secondary.main,
  },
  listContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: 35,
    overflow: 'hidden',
    border: 'solid 1px #adadad',
  },
  primaryListItemText: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 'inherit',
      fontWeight: 'bold',
    },
  },
  newSecondaryHeading: {
    // fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.green,
    color: '#fff',
    borderRadius: 10,
    padding: '16px 10px 16px 10px !important',
    marginRight: '10px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(10),
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(15),
    },
  },
  newThirdHeading: {
    fontSize: theme.typography.pxToRem(15),
    backgroundColor: theme.palette.orange,
    color: '#fff',
    borderRadius: 10,
    padding: '16px 10px 16px 10px !important',
    marginRight: '32px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('xs')]: {
      fontSize: theme.typography.pxToRem(10),
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(12),
    },
    [theme.breakpoints.up('md')]: {
      fontSize: theme.typography.pxToRem(15),
    },
  },
  newHeading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginBottom: 5,
  },
  createdHeading: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  listItemButton: {
    '&:hover': {
      backgroundColor: '#C0DEFB',
    },
  },
});
